import { useState } from "react";
import { Button } from "react-bulma-components";
import { useTranslation } from "react-i18next";
import { requestBoardInvite } from "../../models/invite";

export type BoardRequestInviteViewProps = {
  boardUid: string;
  boardTitle: string;
  hasInvite: boolean;
  onDecline: () => void;
  onRequested: () => void;
};

export function BoardRequestInviteView({ boardUid, boardTitle, hasInvite, onDecline, onRequested }: BoardRequestInviteViewProps) {
  const { t } = useTranslation();
  const [requesting, setRequesting] = useState(false);

  const handleRequest = async () => {
    setRequesting(true);
    try {
      await requestBoardInvite(boardUid);
      onRequested();
    } catch {
      setRequesting(false);
    }
  };

  if (hasInvite) {
    return (
      <div className="box">
        <p className="title is-4">{t("modal.invite.private-title")}</p>
        <p className="subtitle">{t("modal.invite.request-pending")}</p>
        <div className="buttons">
          <Button onClick={onDecline}>{t("error.goBack")}</Button>
        </div>
      </div>
    );
  }

  return (
    <div className="box">
      <p className="title is-4">{t("modal.invite.private-title")}</p>
      <p className="subtitle">{t("modal.invite.private-description")}</p>
      <div className="buttons">
        <Button color="primary" onClick={handleRequest} loading={requesting} disabled={requesting}>
          {requesting ? t("modal.invite.requesting") : t("modal.invite.request")}
        </Button>
        <Button onClick={onDecline}>{t("error.goBack")}</Button>
      </div>
    </div>
  );
}
